import { init, RematchRootState } from '@rematch/core';
import models from './models/models';

const store = init({ models });

export default store;

export type InsightDispatch = typeof store.dispatch;
export type iRootState = RematchRootState<typeof models>;
